'use strict';

export default angular
  .module('maestro.services.clipboard', [])
  .service('ClipboardService', ClipboardService)
  .name;

function ClipboardService($q) {

  angular.extend(this, {
    copyText: copyText
  });

  /**
   * Copy text to clipboard
   * @param {string} text
   * @return {Promise}
   */
  function copyText(text) {
    // feature detection
    if (navigator && navigator.clipboard && navigator.clipboard.writeText) {
      // Async Clipboard API is available
      // It requires permission.
      // Permission for copy-to-clipboard is automatically granted to focused https pages
      // If Permission was not granted - it will be automatically requested from user

      return $q.when(navigator.clipboard.writeText(text))
        .then(() => {
          // console.log('Copying to clipboard was successful!');
        }, err => {
          // if rejected, permission is denied or document is out of focus
          console.error('Could not copy text: ', err);
        });
    } else {
      // Do it in old way
      return legacyCopyTextToClipboard(text);
    }
  }

  function legacyCopyTextToClipboard(text) {
    let textArea = document.createElement('textarea');

    // Place in top-left corner of screen regardless of scroll position.
    textArea.style.position = 'fixed';
    textArea.style.top = '0';
    textArea.style.left = '0';

    // Ensure it has a small width and height. Setting to 1px / 1em
    // doesn't work as this gives a negative w/h on some browsers.
    textArea.style.width = '2em';
    textArea.style.height = '2em';

    // We don't need padding, reducing the size if it does flash render.
    textArea.style.padding = '0';

    // Clean up any borders.
    textArea.style.border = 'none';
    textArea.style.outline = 'none';
    textArea.style.boxShadow = 'none';

    // Avoid flash of white box if rendered for any reason.
    textArea.style.background = 'transparent';

    textArea.value = text;

    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    let promise;
    try {
      let successful = document.execCommand('copy');
      if (!successful || successful === 'unsuccessful') {
        console.error('Could not copy text: copy command was unsuccessful');
        promise = $q.reject();
      } else {
        console.log('Copying to clipboard was successful!');
        promise = $q.when();
      }
    } catch (err) {
      console.error('Could not copy text: ', err);
      promise = $q.reject(err);
    }

    document.body.removeChild(textArea);
    return promise;
  }

}
